fragment subsidyCategoryContent on subsidyCategory_Category {
    id
    title
    uri
    level
    slug
    richTextMinimal
}
